function decodeHtmlEntities(text) {
  const element = document.createElement('textarea')
  element.innerHTML = text
  return element.value
}

export function isTextOnlyUnicodeEmojis(text) {
  if (!text) {
    return false
  }
  const noBr = text.replace(/<br\s*\/?>/gi, '')
  const decoded = decodeHtmlEntities(noBr)
  const cleaned = decoded.replace(/\s+/g, '')
  if (cleaned === '') {
    return false
  }

  const onlyUnicodeEmojiRegex = /^(?:(?:\p{Extended_Pictographic}(?:\uFE0F)?(?:\p{Emoji_Modifier})?(?:\u200D\p{Extended_Pictographic}(?:\uFE0F)?(?:\p{Emoji_Modifier})?)*)|(?:[0-9#*](?:\uFE0F)?\u20E3)|(?:\p{Regional_Indicator}{2}))+$/u
  return onlyUnicodeEmojiRegex.test(cleaned)
}

// Count UTF-8 emojis in text, handling complex sequences (ZWJ, skin tones, flags, keycaps) as single emojis
export function countUnicodeEmojis(text) {
  if (!text) {
    return 0
  }
  const noBr = text.replace(/<br\s*\/?>/gi, '')
  const decoded = decodeHtmlEntities(noBr)
  const cleaned = decoded.replace(/\s+/g, '')
  if (cleaned === '') {
    return 0
  }

  // Match each emoji sequence as a single unit:
  // - Extended pictographics with optional variation selector and skin tone modifier
  // - ZWJ sequences (family emojis, profession emojis, etc.)
  // - Keycap sequences (0-9, #, *)
  // - Regional indicator pairs (flags)
  const emojiRegex = /(?:\p{Extended_Pictographic}(?:\uFE0F)?(?:\p{Emoji_Modifier})?(?:\u200D\p{Extended_Pictographic}(?:\uFE0F)?(?:\p{Emoji_Modifier})?)*)|(?:[0-9#*](?:\uFE0F)?\u20E3)|(?:\p{Regional_Indicator}{2})/gu
  const matches = cleaned.match(emojiRegex)
  return matches ? matches.length : 0
}
